// Portado de src/components/tratamento/Faq.astro (site Astro).
export interface FaqItem {
  pergunta: string;
  resposta: string;
}

export interface FaqProps {
  titulo: string;
  itens: FaqItem[];
}

export function Faq({ titulo, itens }: FaqProps) {
  return (
    <section className="faq">
      <div className="container">
        <div className="faq-titulo">
          <p className="sobretitulo">DÚVIDAS FREQUENTES</p>
          <h2>{titulo}</h2>
        </div>
        {itens.map((f, i) => (
          <details className="frow" open={i === 0} key={i}>
            <summary>
              <span className="frow-n">{String(i + 1).padStart(2, "0")}</span>
              <h3>{f.pergunta}</h3>
              <span className="frow-sinal" aria-hidden="true" />
            </summary>
            <div className="frow-corpo">
              <p>{f.resposta}</p>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}
